module.exports = __webpack_public_path__ + "img/ig_logo_bk.172f6584.svg";